import angular from 'angular';
import templateModalKjson from '~/components/oo-admin/modal/modal-kjson.html';
import ModalKjsonController from '~/components/oo-admin/modal/modal-kjson.controller';

export default class KformTabFormController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} User
	 */
	constructor($element, $scope, $timeout, $uibModal, User) {
		this.$element = $element;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModal = $uibModal;

		this.comments = [];

		this.commentOptions = {
			defaultType: 'K_NODE;KNOTECTXTYPE_perso',
			showTypes:   true,
		};

		/** @type {boolean} */
		this.disabled = true;

		/** @type {?import('~/scripts/services/model/file-upload').default[]} */
		this.files = [];

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		/** @type {?import('../kform.controller').default} */
		this.kform = null;

		this.kid = undefined;

		/** @type {any} */
		this.submission = undefined;
	}

	/**
	 * @param {Event} event
	 */
	async openFormComponents(event) {
		event.preventDefault();

		const data = await this.$uibModal.open({
			template:     templateModalKjson,
			controller:   ModalKjsonController,
			controllerAs: '$ctrl',
			size:         'lg',
			resolve:      {
				label:    () => this.form?.name,
				disabled: () => false,
				kjson:    () => this.form?.components,
			},
		}).result;
		this.$timeout(() => {
			if (this.form) {
				this.form.components = data.kjson;
			}
		});
	}

	/**
	 * @param {Event} event
	 */
	async openSubmissionData(event) {
		event.preventDefault();

		const data = await this.$uibModal.open({
			template:     templateModalKjson,
			controller:   ModalKjsonController,
			controllerAs: '$ctrl',
			size:         'lg',
			resolve:      {
				label:    () => this.form?.name,
				disabled: () => false,
				kjson:    () => JSON.parse(angular.toJson(this.submission.data)),
			},
		}).result;
		this.$timeout(() => {
			this.submission.data = data.kjson;
		});
	}

	$onInit() {
		this.$element.bind('wheel', () => {
			this.$scope.$broadcast('Form.closeDatepickerPopup');
		});
	}
}
